import { TextRegionEntity } from "~/interfaces/entities/TextRegion"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: textRegions, selectors: textRegionsSelectors } =
  createEntitySlice<TextRegionEntity>("textRegions")
